import { BaseAlertInfoDto, MessageDto } from '@siza-staff-care/shared/data';

export const EventBusEvents = {
	Event_Favourites_Changed: 'Event_Favourites_Changed',
	Event_Refresh_Dashboards: 'Event_Refresh_Dashboards',

	/**
	 * Event caused by the unified poller when new messages are received.
	 * The data is a NewMessagesEventData object, and the messages contain *just* the new messages received.
	 */
	Event_NewMessages: 'poll:newMessages',

	Event_NewAlerts: 'poll:newAlerts',
	Event_MessageRefresh: 'poll:messageRefresh',
	Event_AlertRefresh: 'poll:alertRefresh',

	/**
	 * Event for the new message snackbar to mark a message as read.
	 */
	Event_SnackBar_MarkMessageRead: 'snackbar:markMessageRead',

	/**
	 * Event for the new message snackbar to trigger opening the messages dropdown.
	 */
	Event_SnackBar_OpenMessages: 'snackbar:openMessages',

	/**
	 * Event to signal a single message has been marked read.
	 * The data is a SingleMessageMarkedReadData object, and the message contains the message that was marked read.
	 */
	Event_SingleMessage_MarkedRead: 'singleMessage:markedRead',

	/**
	 * Used by message detail component to signal to the staff messages to route to the reply slide-out
	 */
	Event_StaffMessages_TriggerReply: 'staffMessages:triggerReply',

	/**
	 * Used by message detail component to signal to the staff messages to route to the reply all slide-out
	 */
	Event_StaffMessages_TriggerReplyAll: 'staffMessages:triggerReplyAll',

	/**
	 * Used to signal a session has started or ended.
	 */
	Event_Session_Start_End: 'session:startEnd',

	/**
	 * Uses to force the menu search to be activated. (From keyboard shortcut)
	 */
	Event_Activate_Menu: 'menu:activate',

	/**
	 * Used to toggle the side menu. (From keyboard shortcut)
	 */
	Event_Toggle_Menu: 'menu:toggle',

	/**
	 * Signals that the TOTP setup is complete.
	 */
	Event_TOTP_Setup_Complete: 'totp:setupComplete',

	/**
	 * Generic way to show a snackbar message from anywhere.
	 */
	Event_ShowSnackbar_Message: 'snackbar:showMessage',
};

export type NewAlertsEventData = {
	alerts: BaseAlertInfoDto[];
	causedBy: object;
};

export type NewMessagesEventData = {
	messages: MessageDto[];
	causedBy: object;
};

export type SingleMessageMarkedReadData = {
	message: MessageDto;
	causedBy: object;
};
